import { _, makeGtmCall } from '../utils.js'

class Modal {
    constructor() {
        this.autoPop = _('true', 'auto-pop').node()
        this.html = document.querySelector('html')
        this.body = document.body
        this.url = new URL(window.location)

        window.addEventListener('keyup', this.escapeModal)

        document.addEventListener('click', (e) => {
            if (e.target && e.target.dataset.behaviour === 'modal') {
                e.preventDefault
                this.changeParams(e.target)
            }
        })
        this.triggerFromParams()

        history.pushState = ((f) =>
            function pushState() {
                const ret = f.apply(this, arguments)
                window.dispatchEvent(new Event('pushState'))
                window.dispatchEvent(new Event('locationchange'))
                return ret
            })(history.pushState)

        history.replaceState = ((f) =>
            function replaceState() {
                const ret = f.apply(this, arguments)
                window.dispatchEvent(new Event('replaceState'))
                window.dispatchEvent(new Event('locationchange'))
                return ret
            })(history.replaceState)

        window.addEventListener('popstate', () => {
            window.dispatchEvent(new Event('locationchange'))
        })
        window.addEventListener('locationchange', this.triggerFromParams)
        if (this.autoPop) {
            this.autoPop.click()
        }
    }

    escapeModal = (e) => {
        const target = document.querySelector('[data-open="true"]')
        if (e.keyCode === 27 && target) {
            const url = new URL(window.location)
            const params = new URLSearchParams(url.search)
            params.delete('modal')
            window.history.pushState(
                null,
                null,
                `${window.location.pathname}${params}${window.location.hash}`,
            )
            this.startScroll(target)
        }
    }

    changeParams = (el) => {
        const url = new URL(window.location)
        const params = new URLSearchParams(url.search)
        let startParams = '?'

        if (params.has('modal')) {
            params.set('modal', el.dataset.hash)
        } else {
            params.append('modal', el.dataset.hash)
        }
        if (window.location.href.match('/?').index) {
            startParams = '&'
        }
        if (typeof el.dataset.hash === 'undefined') {
            startParams = ''
            params.delete('modal')
        }
        window.history.pushState(
            null,
            null,
            `${window.location.pathname}${startParams}${params}${window.location.hash}`,
        )
    }

    triggerFromParams = () => {
        const url = new URL(window.location)
        const params = new URLSearchParams(url.search)
        const openModal = document.querySelector('[data-open="true"]')

        if (openModal && params.get('modal') === null) {
            this.toggleModal(
                document.querySelector(
                    `[data-target="${openModal.dataset.element}"]`,
                ),
            )
        }
        if (params.get('modal') === '' || params.get('modal') === null) {
            this.startScroll()
            return false
        }

        if (!openModal && params.get('modal') !== null) {
            const triggerEl = document.querySelector(
                `[data-target="${params.get('modal')}"]`,
            )
            if (triggerEl) {
                this.toggleModal(triggerEl)
            }
        }
    }

    toggleModal = (el) => {
        const trigger = el
        const target = _(trigger.dataset.target, 'element').node()
        const triggerClass = trigger.dataset.class
        const targetClass = target.dataset.class
        const clickEvent = new Event('click')

        target.classList.toggle(targetClass)
        const modalOpen = target.classList.contains(targetClass)
        target.dataset.open = modalOpen

        trigger.dataset.gtmEvent = trigger.dataset.gtmEvent || 'modal-open'
        trigger.dataset.gtmName =
            trigger.dataset.gtmName || trigger.dataset.hash
        if (modalOpen) {
            makeGtmCall(el)
            if (target.querySelector('input')) {
                setTimeout(() => {
                    target.querySelector('input').focus()
                }, 300)
            }
        } else {
            if (
                target.querySelector(_('response-container', 'element').str())
            ) {
                target.querySelector(
                    _('response-container', 'element').str(),
                ).innerHTML = ''
            }

            if (target.querySelector('input')) {
                target.querySelector('input').blur()
            }
        }

        if (triggerClass) {
            trigger.classList.toggle(triggerClass)
        }

        if (modalOpen && trigger.dataset.drift === 'true') {
            const iFrame = document.createElement('iframe')
            iFrame.classList.add('modal__iframe')
            const iframeContainer = target.querySelector(
                _('drift-container', 'element').str(),
            )

            iFrame.src = iframeContainer.dataset.driftUrl
            iFrame.classList.add('chat-frame')
            iframeContainer.appendChild(iFrame)
        }
        if (!modalOpen && trigger.dataset.drift === 'true') {
            const iFrame = document.querySelector('.chat-frame')
            if (iFrame) {
                iFrame.remove()
            }
        }

        if (modalOpen && trigger.dataset.video === 'true') {
            _('video-play').nodeFrom(target).dispatchEvent(clickEvent)
        }

        if (!modalOpen && trigger.dataset.video === 'true') {
            _('video-pause').nodeFrom(target).dispatchEvent(clickEvent)
        }
        if (!modalOpen) {
            const form = _('form-post').nodeFrom(target)
            form?.classList.remove('u-hidden')
            const formMessages = _('form-message', 'group').nodesFrom(target)
            formMessages?.forEach((message) => {
                message.classList.add('u-hidden')
            })
        }

        this.toggleScroll(target)
    }

    stopScroll = (target) => {
        target.dataset.open = true
        target.dataset.position = window.pageYOffset
        this.body.style.height = `${window.outerHeight}px`
        this.body.style.overflow = 'hidden'
        this.body.classList.add('body--modal')
        window.scrollTo(0, 0)
    }

    startScroll = (target = false) => {
        this.body.style.height = 'auto'
        this.body.style.overflow = 'auto'
        this.body.classList.remove('body--modal')
        if (target) {
            target.dataset.open = false
            window.scrollTo(0, target.dataset.position)
        }
    }

    toggleScroll = (target) => {
        if (!target.dataset.open || target.dataset.open === 'true') {
            this.stopScroll(target)
        } else {
            this.startScroll(target)
        }
    }
}

export default Modal
